import {
  FETCH_BLOCKED_USERS,
  FETCH_BLOCKED_USERS_SUCCESS,
  FETCH_BLOCKED_USERS_FAILED,
  BLOCK_USER,
  UNBLOCK_USER,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, set, remove, off } from 'firebase/database';

export const fetchBlockedUsers = () => (dispatch) => {
  const { userBlocksRef } = firebase;
  const uid = store.getState().auth.profile?.uid;
  if (!uid) return;

  dispatch({ type: FETCH_BLOCKED_USERS, payload: null });
  off(userBlocksRef(uid));
  onValue(userBlocksRef(uid), (snapshot) => {
    dispatch({
      type: FETCH_BLOCKED_USERS_SUCCESS,
      payload: snapshot.val() || {},
    });
  }, () => {
    dispatch({
      type: FETCH_BLOCKED_USERS_FAILED,
      payload: 'blocked_users_error',
    });
  });
};

export const blockUser = (blockedUid, blockedName, bookingId) => (dispatch) => {
  const { userBlockEntryRef } = firebase;
  const uid = store.getState().auth.profile?.uid;
  if (!uid || !blockedUid || uid === blockedUid) {
    return Promise.resolve(false);
  }

  const entry = {
    blockedUid,
    blockedName: blockedName || '',
    bookingId: bookingId || '',
    createdAt: Date.now(),
  };

  dispatch({ type: BLOCK_USER, payload: entry });
  return set(userBlockEntryRef(uid, blockedUid), entry);
};

export const unblockUser = (blockedUid) => (dispatch) => {
  const { userBlockEntryRef } = firebase;
  const uid = store.getState().auth.profile?.uid;
  if (!uid || !blockedUid) return Promise.resolve(false);

  dispatch({ type: UNBLOCK_USER, payload: { blockedUid } });
  return remove(userBlockEntryRef(uid, blockedUid));
};

export const isUserBlocked = (blockedMap, uid) => !!(blockedMap && uid && blockedMap[uid]);
